// userApi.ts
export interface User {
  id: string | null;
  name: string | null;
  tone: string | null;
  picture_extension: string | null;
  picture_data: string | null;
  paid: boolean;
  start_dt: string | null;
  end_dt: string | null;
  tutor_cnt: number;
  socra_cnt: number;
}

export interface UserApiResponse {
  profile_id: string;
  name: string;
  tone: string;
  picture_extension: string;
  picture_data: string;
  paid: boolean;
  start_dt: string;
  end_dt: string;
  tutor_cnt: number;
  socra_cnt: number;
}

/**
 * 사용자 로그인 상태 및 정보를 확인하는 API
 * @returns User 객체 또는 null (로그아웃 상태)
 */
export const fetchUserAPI = async (): Promise<User | null> => {
  try {
    const result = await fetch(
      `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_LOGIN_CHECK_URL}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (result.status === 200 || result.status === 201) {
      const resData: UserApiResponse = await result.json();

      // localStorage에 저장
      localStorage.setItem("userInfo", JSON.stringify(resData));

      return {
        id: resData.profile_id,
        name: resData.name,
        tone: resData.tone,
        picture_extension: resData.picture_extension,
        picture_data: resData.picture_data,
        paid: resData.paid,
        start_dt: resData.start_dt,
        end_dt: resData.end_dt,
        tutor_cnt: resData.tutor_cnt,
        socra_cnt: resData.socra_cnt,
      };
    } else if (result.status === 401) {
      // 로그아웃 상태
      localStorage.removeItem("userInfo");
      return null;
    }

    // 기타 에러 상태(5xx 등)
    // 서버가 토큰 검증 실패를 500 으로 반환하는 경우가 있어, 여기서 스토리지를
    // 정리하지 않으면 손상된 세션 정보가 남아 새로고침해도 계속 실패한다.
    console.error("사용자 상태 확인 실패:", result.status, result.statusText);
    localStorage.removeItem("userInfo");
    return null;
  } catch (error) {
    // 네트워크 오류 또는 CORS 차단(예: 500 응답에 CORS 헤더가 없어
    // 브라우저가 응답을 차단하는 경우)으로 상태를 확인할 수 없는 상황.
    // 이때도 스토리지를 정리해 로그인 상태가 고착되지 않도록 한다.
    console.error("Failed to fetch user:", error);
    localStorage.removeItem("userInfo");
    return null;
  }
};
